import React, { useEffect, useState } from "react";
import { IconType } from "react-icons";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { SiGooglecalendar } from "react-icons/si";
import { VscBook } from "react-icons/vsc";
import { TfiPencilAlt } from "react-icons/tfi";
import { useGetCourseByIdQuery } from "src/services/CourseServices";

type Props = {};

export const courseLayoutTabs: {
  label: string;
  icon: IconType;
  path: string;
  moduleName: string;
  actionName: string;
}[] = [
  {
    label: "DETAILS",
    icon: TfiPencilAlt,
    path: "details",
    moduleName: UserModuleNameTypes.INQUIRIES,
    actionName: UserModuleActionTypes.INQUIRIES_EDIT_DETAILS,
  },
  {
    label: "DAY-PLANING",
    icon: SiGooglecalendar,
    path: "day-planing",
    moduleName: UserModuleNameTypes.INQUIRIES,
    actionName: UserModuleActionTypes.INQUIRIES_EDIT_FOLLOWUP,
  },
  {
    label: "SUB-COURSES",
    icon: VscBook,
    path: "sub-courses",
    moduleName: UserModuleNameTypes.INQUIRIES,
    actionName: UserModuleActionTypes.INQUIRIES_EDIT_FOLLOWUP,
  },
];

const CourseLayout = (props: Props) => {
  const { userType } = useSelector((state: RootState) => state.auth);
  const [courseData, setCourseData] = useState<any>([]);
  const {courseId} = useParams()

  const navigate = useNavigate();
  const location = useLocation();

  const {
    data: courseDataById,
    isLoading: isCourseLoading,
    isFetching: isCourseFetching,
  } = useGetCourseByIdQuery({
    id: courseId,
  }); 

  

  useEffect(() => {
    if (!isCourseFetching && !isCourseLoading) {
      setCourseData(courseDataById?.data);
    }
  }, [courseDataById?.data, isCourseLoading, isCourseFetching]);

  const currentPath = location.pathname.split("/")[4];

  //QUERY

  return (
    <div className="flex flex-col gap-2 pt-3 h-full">
      {/* courseLayoutTabs */}
      {courseLayoutTabs?.length && (
        <div className="flex gap-3 items-center    border-b border-slate-400 bg-white ">
          {courseLayoutTabs
            ?.filter((module: any) =>
              userType === "ADMIN"
                ? true
                : isCheckActionsPermission({
                    moduleName: module?.moduleName,
                    actionName: module?.actionName,
                  })
            )
            ?.map((tab: any, index: any) => {
              return (
                <div key={index}>
                  <button
                    type="button"
                    onClick={() => navigate(tab.path)}
                    className={`h-full px-5 pb-2 flex gap-2 border-b-[3px]  items-center hover:text-primary-main font-medium text-sm transition-all
        ${
          currentPath === tab.path?.split("/")[0]
            ? "text-primary-main   border-primary-main"
            : "text-gray-700 border-white"
        }
         `}
                  >
                    <div className=" text-lg  ">
                      <tab.icon />
                    </div>
                    {tab.label}
                  </button>
                </div>
              );
            })}
        </div>
      )}
       <div className="border-b border-slate-300 px-4 py-2">
                <div className="flex gap-3">
                  {/* Avatar  */}
                  <div className="w-[30px] aspect-square rounded bg-primary-main text-white flex justify-center items-center text-xl font-semibold capitalize ">
                    {courseData?.courseName?.[0]}{" "}
                  </div>

                  <div className="flex flex-col">
                    {/* Name */}
                    <div className="text-primary-dark font-semibold text-xl capitalize">
                      {courseData?.courseName}
                    </div>
                  </div>
                </div>
              </div>

      {/* Outlet */}
      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
};

export default CourseLayout;
